import { GET_SUB_CATEGORIES_LIST, ADD_SUB_CATEGORY, EDIT_SUB_CATEGORY } from './ApiConstants';
import api from './ApiHandler';

export const getSubCategoriesByPage = async (payload: any) => {
  return await api.get(GET_SUB_CATEGORIES_LIST, { params: { ...payload } });
};

export const createSubCategory = async (payload: any) => {
  return await api.post(ADD_SUB_CATEGORY, { ...payload });
};

export const editSubCategory = async (payload: any) => {
  return await api.post(EDIT_SUB_CATEGORY, { ...payload });
};
